export const AMAZON_URL = `${import.meta.env.BUILD_API_BASE_URL}/amazon/v1`;
export const AMAZON_URL_V2 = `${import.meta.env.BUILD_API_BASE_URL}/amazon/v2`;
